import axios from 'axios';

export const fetchDistrictList = (divisionId: number) =>
  axios({
    method: 'GET',
    url: '/user-service/user/tagged-districts',
    params: {
      divisionId
    }
  });
